import FormCompletionActions from './constants';
import { IActionObject } from './types';

const INITIAL_STATE: boolean = false;

export default function formCompletionReducer(
  state: any = INITIAL_STATE,
  action: IActionObject
): boolean {
  const { data } = action;
  switch (action.type) {
    case FormCompletionActions.SET_FORM_COMPLETION:
      return data.completed;
    default:
      return state;
  }
}
